import { UnleashClient } from 'unleash-proxy-client';
import config from '@/config';

const unleash =
  config.unleashUrl && config.unleashKey
    ? new UnleashClient({
        url: config.unleashUrl || '',
        clientKey: config.unleashKey || '',
        appName: 'vue',
        disableRefresh: true,
      })
    : {
        isEnabled: () => false,
      };

export default unleash;
